import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons'

//! only these icons can be used in components
library.add(faTiktok, faYoutube)

export default FontAwesomeIcon
